import { render, staticRenderFns } from "./editebm.vue?vue&type=template&id=1c8835e6&scoped=true&"
import script from "./editebm.vue?vue&type=script&lang=js&"
export * from "./editebm.vue?vue&type=script&lang=js&"
import style0 from "./editebm.vue?vue&type=style&index=0&id=1c8835e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8835e6",
  null
  
)

export default component.exports